import { TUser } from '../../../../types/user';

interface IWebimUserData {
  fields: {
    id: string;
    display_name?: string;
  };
  hash: string;
}

export function prepareUserData(data: TUser): IWebimUserData | null {
  if (data.isAuthenticated && data.webimHash) {
    const fields: IWebimUserData['fields'] = { id: `${data.userId}` };

    if (data.displayName) {
      fields.display_name = data.displayName;
    }

    return {
      fields,
      hash: data.webimHash,
    };
  }

  return null;
}
